import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addProcessingtype,
  getProcessingtypes,
  getProcessingtype,
  editProcessingtype,
  deleteProcessingtype,
  getAllProcessingtypes,
} from "../../store/actions/processingtype_action";
import { SEARCH_TERMS } from "../enums/processingtypes_enum";
// Get All Data
export const useAllProcessingtypes = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.processingtype);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteProcessingtype(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getProcessingtypes({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getProcessingtypes({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getProcessingtypes({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleProcessingtype = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.processingtype);
  useEffect(() => {
    dispatch(getProcessingtype(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateProcessingtype = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addProcessingtype(data));
  };
  return [addData];
};
export const useUpdateProcessingtype = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editProcessingtype(id, data));
  };
  return [updateData];
};

export const useSelectAllProcessingtype = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.processingtype);
    useEffect(() => {
      dispatch(getAllProcessingtypes());
    }, []);
    return [data];
  };      